import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { Badge } from "components/badge/Badge";

import CreditBookCustomerTagBadge from "./CreditBookCustomerTagBadge";

import "./creditBookCustomerTags.scss";

interface ICustomerTag {
  id: number;
  label: string;
  colour?: string;
}

interface IProps {
  tags: ICustomerTag[];
  popoverId: string | number;
}

const MAX_VISIBLE_TAGS = 2;

export default function CreditBookCustomerTags(props: IProps) {
  const { tags, popoverId } = props;

  if (tags.length === 0) {
    return <p className="field-unavailable">-</p>;
  }

  const visibleTags = tags.slice(0, MAX_VISIBLE_TAGS);
  const remainingTags = tags.slice(MAX_VISIBLE_TAGS);

  return (
    <div className="credit-books-customer-tags">
      {visibleTags.map(tag => (
        <CreditBookCustomerTagBadge key={tag.id} label={tag.label} colour={tag.colour} />
      ))}
      {remainingTags.length > 0 ? (
        <OverlayTrigger
          placement="top"
          trigger={["hover", "focus"]}
          overlay={
            <Popover id={`credit-book-tags-popover-${popoverId}`} className="credit-books-customer-tags-popover">
              <Popover.Content>
                <div className="credit-books-customer-tags-popover-content">
                  {remainingTags.map(tag => (
                    <CreditBookCustomerTagBadge key={tag.id} label={tag.label} colour={tag.colour} />
                  ))}
                </div>
              </Popover.Content>
            </Popover>
          }
        >
          <span className="credit-books-customer-tags-more">
            <Badge type="gray" size="small">
              +{remainingTags.length}
            </Badge>
          </span>
        </OverlayTrigger>
      ) : null}
    </div>
  );
}
